import { render } from "./ModalNuevoTicket.vue?vue&type=template&id=66668052&scoped=true"
import script from "./ModalNuevoTicket.vue?vue&type=script&lang=js"
export * from "./ModalNuevoTicket.vue?vue&type=script&lang=js"

import "./ModalNuevoTicket.vue?vue&type=style&index=0&id=66668052&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66668052"]])

export default __exports__